import { Role } from "../types/shared-module-types";
import {
  BILLING_MODULE,
  PRODUCTS_CREATOR,
  PRODUCTS_DELETE,
  ROLE_BILLING_MODULE,
  ROLE_BILLING_MODULE_PERFORM_ACTION,
  ROLE_BILLING_MODULE_PERFORM_SEARCH,
  ROLE_BILLING_OWNERS,
  ROLE_CLIENT_ADMIN,
  ROLE_DELIVERY_TIME_ADMIN,
  ROLE_INVOICE_VIEWER,
  ROLE_NOT_OWNERS,
  ROLE_PROJECT_OWNER,
  ROLE_RECURRING_BILLING_ADMIN,
  ROLE_SUPER_ADMIN,
  ROLE_SUPERVISOR,
  ROLE_TIMESHEETS_ADMIN,
  ROLE_USERS_ADMIN,
  ROLE_USERS_VIEWER,
} from "./constants";

/* check access for The Module
- first param: ask is need to check roles access
- second param: roles needed to access
- third param: roles that user has in module
*/
export const verifyModuleAccess = (
  requireModuleAccess: boolean | undefined,
  rolesModuleAccess: string[] | undefined,
  rolesModuleList: string[] | undefined
) => {
  let response: any = false;
  if (!requireModuleAccess) {
    response = true;
  } else if (requireModuleAccess) {
    response = rolesModuleAccess?.some((elem) =>
      rolesModuleList?.includes(elem)
    );
  }
  return response;
};

export const hasSuperAdminAccess = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(true, [ROLE_SUPER_ADMIN], userRolesList);
};

// Param is array of roles
export const isUserAdminOrSuperAdmin = (
  userRolesList: string[] | undefined
) => {
  return verifyModuleAccess(
    true,
    [ROLE_SUPER_ADMIN, ROLE_USERS_ADMIN],
    userRolesList
  );
};

// Param is array of roles only for time module
export const canSeeAllUsers = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(
    true,
    [ROLE_SUPER_ADMIN, ROLE_USERS_ADMIN, ROLE_USERS_VIEWER],
    userRolesList
  );
};

export const isInvoiceViewer = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(true, [ROLE_INVOICE_VIEWER], userRolesList);
};

export const billingNotOwners = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(true, ROLE_NOT_OWNERS, userRolesList);
};

export const billingOwners = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(true, ROLE_BILLING_OWNERS, userRolesList);
};

export const billingModule = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(true, ROLE_BILLING_MODULE, userRolesList);
};

export const billingModulePerformSearch = (
  userRolesList: string[] | undefined
) => {
  return verifyModuleAccess(
    true,
    ROLE_BILLING_MODULE_PERFORM_SEARCH,
    userRolesList
  );
};

export const billingModulePerformAction = (
  userRolesList: string[] | undefined
) => {
  return verifyModuleAccess(
    true,
    ROLE_BILLING_MODULE_PERFORM_ACTION,
    userRolesList
  );
};

export const roleDeleteProduct = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(true, PRODUCTS_DELETE, userRolesList);
};

export const roleCreateProduct = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(true, PRODUCTS_CREATOR, userRolesList);
};

export const hasMultipleBillingRole = (
  userRoles: Role[] | null | undefined
) => {
  let multipleBillingRole: Role[] = [];
  userRoles?.forEach((role) => {
    if (role.module.name.toLowerCase() === BILLING_MODULE) {
      multipleBillingRole.push(role);
    }
  });
  return multipleBillingRole;
};

// ASUITE11-2647
export const isOnlyRecurringBillingAdminRole = (
  userRoles: Role[] | null | undefined
) => {
  let response: boolean = false;
  let multipleBillingRole: any = [];
  userRoles?.forEach((role) => {
    if (role.module.name.toLowerCase() === BILLING_MODULE) {
      multipleBillingRole.push(role);
    }
  });
  if (
    multipleBillingRole.length === 1 &&
    multipleBillingRole[0].name === ROLE_RECURRING_BILLING_ADMIN
  ) {
    response = true;
  }
  return response;
};

// Helper to know if have a access to a module by role
export const hasAccessToModuleInHeader = (
  userRoles: Role[] | null | undefined,
  module: string[]
) => {
  let result =
    userRoles?.some((role) =>
      Array.isArray(module)
        ? module.find((allowedRoles) => allowedRoles === role.name)
        : module === role.name
    ) || false;
  return result;
};

// Param is array of roles only for time module
export const isSupervisor = (userRolesList: string[] | undefined) => {
  return verifyModuleAccess(true, [ROLE_SUPERVISOR], userRolesList);
};

// Param is array of roles only for time module
export const isSupervisorOrProjectOwner = (
  userRolesList: string[] | undefined
) => {
  return verifyModuleAccess(
    true,
    [ROLE_SUPERVISOR, ROLE_PROJECT_OWNER],
    userRolesList
  );
};

// Param is array of roles only for time module
export const hasSuperTimeAdminAccess = (
  userRolesList: string[] | undefined
) => {
  return verifyModuleAccess(
    true,
    [ROLE_SUPER_ADMIN, ROLE_TIMESHEETS_ADMIN],
    userRolesList
  );
};

// Param is array of roles only for time module
export const isSuperAdminOrClientAdmin = (
  userRolesList: string[] | undefined
) => {
  return verifyModuleAccess(
    true,
    [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    userRolesList
  );
};

// Param is array of roles
export const isDeliveryTimeAdminChecker = (userRoles: string[] | undefined) => {
  let response: boolean = false;
  if (userRoles) {
    for (const role of userRoles) {
      if (role === ROLE_DELIVERY_TIME_ADMIN) {
        response = true;
        break;
      }
    }
  }
  return response;
};
